module.exports = __webpack_public_path__ + "static/media/feature_3.6b4c57e5.png";